import React, { ReactNode, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import TerminalHeader from './TerminalHeader';
import TerminalAside from './TerminalAside';
import './chrome.scss';

interface TerminalChromeProps {
  children: ReactNode;
}

/**
 * TerminalChrome — the layout shell that replaces Metronic's MasterLayout
 * internals when the Terminal theme is active. Owns its own header and
 * aside; the child `{children}` is the route outlet, identical to the
 * default layout. Routes don't need to know which chrome wraps them.
 *
 * Mobile aside toggling is the only state this component holds; header and
 * aside stay pure otherwise.
 */
const TerminalChrome: React.FC<TerminalChromeProps> = ({ children }) => {
  const [mobileAsideOpen, setMobileAsideOpen] = useState(false);
  const location = useLocation();

  // Close the mobile aside whenever the route changes — tapping a menu item
  // or otherwise navigating should dismiss the overlay.
  useEffect(() => {
    setMobileAsideOpen(false);
  }, [location.pathname]);

  return (
    <div className="term-chrome">
      <TerminalHeader
        onMenuToggle={() => setMobileAsideOpen((o) => !o)}
        mobileMenuOpen={mobileAsideOpen}
      />
      <div className="term-chrome__body">
        <TerminalAside
          mobileOpen={mobileAsideOpen}
          onClose={() => setMobileAsideOpen(false)}
        />
        <main className="term-chrome__content">{children}</main>
      </div>
    </div>
  );
};

export default TerminalChrome;
